import React from 'react';
import bus from 'assets/images/movimiento-bus.png';
import { Link } from 'react-router-dom';

export default function Movimiento() {
  return (
    <div className='movimiento'>
        <div className="logo">
            <h3>Incluir en movimiento</h3>
        </div>
        <figure>
            <img src={bus} alt="Imagen de bus" />
        </figure>
        <figcaption>
            <p>Presentamos el ciclo itinerante de educación financiera que llega a distintas localidades de la Provincia</p>
            <Link className="btn-verde" to="/movimiento">Conocé más</Link>
        </figcaption>
    </div>
  );
}